/**
 * Varyant Seçimi Zorunlu — Standart halı ürünleri (Perfecto, vb.) için
 *
 * Shopify/HDT tema davranışı: ilk varyant otomatik seçili + hidden form id'si onun ID'si.
 * Kullanıcı farklı boyut tıklasa bile, HDT'nin variant-update listener'ı hidden id'yi
 * güncellemeyebiliyor → yanlış varyant sepete ekleniyor.
 *
 * Bu script:
 *  1) Sayfa yüklenince tüm "Boyut" radyolarını DESELECT eder (varsayılan yok)
 *  2) /products/{handle}.js ile variant title → variant id haritasını çıkarır
 *  3) Kullanıcı bir boyut seçer → hidden form id'yi zorla eşleştirir
 *  4) ATC tıklamasında boyut seçilmediyse engeller + uyarı
 *  5) Özel ölçü ürünlerinde (window.__OZEL_OLCU_CONFIG__) çalışmaz
 *  6) (2026-07-28) Sayfanın gösterdiği varsayılan ölçü otomatik işaretlenir — preselectInitial()
 *  8) (2026-07-29b) Seçili ölçünün indirim kazancı TL olarak fiyat altına yazılır — updateSavings()
 * 10) (2026-07-29d/v7) HİDRASYON-ÖNCESİ GÖNDERİM KORUMASI: bileşen ~31 sn geç tanımlanıyor;
 *     tanımsızken submit'i biz yapıyoruz (çıplak 400 sayfası imkânsız hale gelir)
 *  9) (2026-07-29c/v6) TIKLAMA-KAYBI SİGORTASI: tema ilk tıklamayı yutabiliyor.
 *     +1500ms ekleme yoksa YENİDEN TIKLANIR (tek doğal ekleme); o da yutulursa ve
 *     sepet değişmediyse son çare tek ekleme + /cart. Çifte-adet korumalı.
 *  7) (2026-07-29) Varsayılan ölçü TÜKENDİYSE stoktaki ilk ölçü seçilir; tümü tükendiyse
 *     body.dv-all-soldout eklenir (özel-ölçü CTA'sı birincile döner)
 */
(function(){
  'use strict';
  window.__vmSurum = 'v7b';  // canli surum probu (minifier bunu koruyacak)
  function isOzelOlcu(){ return !!window.__OZEL_OLCU_CONFIG__ || !!document.getElementById('ozel-olcu-plus'); }

  function getBoyutRadios(){
    return document.querySelectorAll('input[type="radio"][name="Boyut"], input[type="radio"][name="Size"], input[type="radio"][name="boyut"]');
  }

  function getIdInput(){ return document.querySelector('form[action="/cart/add"] input[name="id"]'); }

  // DV_ATTRIBUTION_VARIANT_FALLBACK_20260817
  function buildDvAttributionFormData(form, variantId){
    var fd = form ? new FormData(form) : new FormData();
    fd.set('id', String(variantId));
    fd.set('quantity', '1');
    try {
      var bridge = window.DVAdsAttribution;
      var ref = bridge && typeof bridge.getRef === 'function' ? bridge.getRef() : '';
      if (/^dvattr_[A-Za-z0-9_-]{30,80}$/.test(String(ref || ''))) {
        fd.set('properties[_dvAttributionRef]', String(ref));
      }
    } catch (_dvAttributionError) {}
    return fd;
  }

  var __variantMap = {}; // { "80x150": 50211646505176, ... }
  var __availMap = {};   // { "80x150": true/false } — stok durumu (2026-07-29)
  var __priceMap = {};   // { "80x150": kuruş } — satış fiyatı (2026-07-29 indirim netliği)
  var __cmpMap   = {};   // { "80x150": kuruş } — üstü çizili liste fiyatı
  var __productHandle = null;

  function loadVariantMap(){
    // Ürün handle'ı URL'den
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return Promise.resolve({});
    __productHandle = m[1];
    return fetch('/products/' + __productHandle + '.js')
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if (!p || !p.variants) return {};
        var hicStokYok = true;
        p.variants.forEach(function(v){
          __variantMap[v.title] = v.id;
          __availMap[v.title] = v.available;
          __priceMap[v.title] = v.price; __cmpMap[v.title] = v.compare_at_price;
          // Bazı Shopify temaları option1/option2/option3 ile tutar
          if (v.option1) { __variantMap[v.option1] = v.id; __availMap[v.option1] = v.available;
            __priceMap[v.option1] = v.price; __cmpMap[v.option1] = v.compare_at_price; }
          if (v.available) hicStokYok = false;
        });
        // 2026-07-29: tüm ölçüler tükendiyse özel-ölçü CTA'sı birincile döner (CSS bu sınıfı okur)
        if (hicStokYok) { try { document.body.classList.add('dv-all-soldout'); } catch(e){} }
        return __variantMap;
      })
      .catch(function(){ return {}; });
  }

  function deselectAll(){
    var rs = getBoyutRadios();
    if (!rs.length) return false;
    for (var i=0;i<rs.length;i++){ rs[i].checked = false; }
    return true;
  }

  function anySelected(){
    var rs = getBoyutRadios();
    for (var i=0;i<rs.length;i++){ if (rs[i].checked) return true; }
    return false;
  }

  function getSelectedValue(){
    var rs = getBoyutRadios();
    for (var i=0;i<rs.length;i++){ if (rs[i].checked) return rs[i].value; }
    return null;
  }

  function syncFormIdToSelection(){
    var val = getSelectedValue();
    if (!val) return;
    var id = __variantMap[val];
    if (!id) return;
    var idInput = getIdInput();
    if (idInput && String(idInput.value) !== String(id)){
      idInput.value = id;
      // Shopify temaları bazen change event dinler — dispatch et
      try { idInput.dispatchEvent(new Event('change', { bubbles: true })); } catch(e){}
      console.log('[VariantMandatory] hidden id güncellendi →', val, '=', id);
    }
  }

  function attachRadioListeners(){
    var rs = getBoyutRadios();
    for (var i=0;i<rs.length;i++){
      rs[i].addEventListener('change', function(){ syncFormIdToSelection(); updateSavings(); setTimeout(updateSavings, 900); });
      rs[i].addEventListener('click', function(){ setTimeout(function(){ syncFormIdToSelection(); updateSavings(); }, 10); setTimeout(updateSavings, 900); });
    }
    // Label click'leri de yakala (radyo focusable değilse)
    var labels = document.querySelectorAll('label.hdt-product-form_value, label[for^="Option"]');
    for (var j=0;j<labels.length;j++){
      labels[j].addEventListener('click', function(){ setTimeout(syncFormIdToSelection, 30); });
    }
  }

  function openWarnModal(){
    var ov = document.getElementById('vm-warn-modal');
    if (!ov){
      ov = document.createElement('div');
      ov.id = 'vm-warn-modal';
      ov.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.55);z-index:99999;display:none;align-items:center;justify-content:center;padding:20px;backdrop-filter:blur(2px);';
      ov.innerHTML = '<div style="background:#fff;max-width:420px;width:100%;border-radius:14px;padding:26px 22px 20px;box-shadow:0 24px 60px rgba(0,0,0,0.35);position:relative;line-height:1.65;">' +
        '<button type="button" aria-label="Kapat" class="vm-close" style="position:absolute;top:8px;right:8px;width:30px;height:30px;border:none;background:#f3f3f3;border-radius:50%;font-size:18px;color:#666;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;line-height:1;">&times;</button>' +
        '<div style="display:flex;align-items:center;gap:10px;margin-bottom:10px;">' +
          '<div style="width:34px;height:34px;border-radius:50%;background:#fff5f0;display:flex;align-items:center;justify-content:center;color:#e8622a;flex-shrink:0;border:1px solid rgba(232,98,42,0.25);">' +
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>' +
          '</div>' +
          '<h3 style="margin:0;font-size:16px;font-weight:700;color:#1a1a1a;">Lütfen Ölçü Seçin</h3>' +
        '</div>' +
        '<p style="margin:0 0 16px;font-size:14px;color:#444;">Sepete eklemeden önce <b>halı ölçüsünü</b> seçmeniz gerekir. Bir ölçü seçeneğine tıklayın.</p>' +
        '<button type="button" class="vm-ok" style="width:100%;padding:10px;background:#e8622a;color:#fff;border:none;border-radius:8px;font-size:14px;font-weight:600;cursor:pointer;">Anladım</button>' +
      '</div>';
      document.body.appendChild(ov);
      function closeM(){ ov.style.display='none'; }
      ov.addEventListener('click', function(e){ if (e.target === ov) closeM(); });
      ov.querySelector('.vm-close').addEventListener('click', closeM);
      ov.querySelector('.vm-ok').addEventListener('click', function(){
        closeM();
        var firstRadio = getBoyutRadios()[0];
        if (firstRadio) {
          var label = firstRadio.closest('label') || firstRadio.nextElementSibling;
          if (label) label.scrollIntoView({ behavior:'smooth', block:'center' });
        }
      });
    }
    ov.style.display = 'flex';
  }

  // DV_GIFT_ADD_VARIANT_BYPASS_20260908: the gift controller owns this exact single-item request, not the PDP variant picker.
  function isGuardedGiftAdd(opts){
    if(!opts || String(opts.method || '').toUpperCase()!=='POST' || typeof opts.body!=='string') return false;
    try {
      var body=JSON.parse(opts.body);
      if(!body || body.id || !Array.isArray(body.items) || body.items.length!==1) return false;
      var item=body.items[0], p=item && item.properties;
      return !!(item && Number.isSafeInteger(Number(item.id)) && Number(item.id)>0 &&
        /^[0-9]{10,16}$/.test(String(item.id)) && item.quantity===1 && p &&
        p._hediye==='1' && p.Hediye==='Kampanya hediyesi — uygunluğu sepette doğrulanır' &&
        typeof p._dvGiftGuard==='string' && /^dvhd-[a-z0-9]{6,12}-[a-z0-9]{1,8}$/.test(p._dvGiftGuard));
    } catch(giftBodyError){ return false; }
  }

  function interceptATC(){
    // v7 (2026-07-29d): HIDRASYON-ONCESI GONDERIM KORUMASI.
    // Olcum: hdt-buy-buttons bileseni sayfadan ~31 sn SONRA tanimlaniyor. O pencerede
    // form CIPLAK submit oluyor ve /cart/add 400 "Parameter Missing" hata sayfasi acilıyor
    // (sticky denemesinde canlida goruldu). Bilesen tanimli degilse gonderimi biz yapiyoruz.
    document.addEventListener('submit', function(e){
      var f = e.target;
      if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
      if (customElements.get('hdt-buy-buttons')) return; // tema uyandi, karismayiz
      e.preventDefault(); e.stopPropagation();
      if (isOzelOlcu()) return false;
      if (!anySelected()){ openWarnModal(); return false; }
      var val = getSelectedValue();
      var vid = __variantMap[val];
      if (!vid || __availMap[val] === false) return false;
      if (window.__vmDirekt) return false;
      window.__vmDirekt = true;
      window.__vmLastCartAdd = Date.now(); // tiklama sigortasi ikinci kez eklemesin
      console.warn('[VariantMandatory] bilesen henuz tanimsiz - gonderim direkt yapiliyor:', val);
      var fd = buildDvAttributionFormData(f, vid);
      fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(function(r){ window.__vmDirekt = false; if (r.ok) window.location.href = '/cart'; })
        .catch(function(){ window.__vmDirekt = false; });
      return false;
    }, true);

    var form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;
    // Form submit yakala
    form.addEventListener('submit', function(e){
      if (!anySelected()){
        e.preventDefault();
        e.stopPropagation();
        openWarnModal();
        return false;
      }
      // Seçim var — hidden id'yi zorla eşleştir (son kontrol)
      syncFormIdToSelection();
    }, true);
    // Button click (fetch tabanlı ATC için)
    var atcBtn = form.querySelector('button[name="add"], button[type="submit"]');
    if (atcBtn){
      atcBtn.addEventListener('click', function(e){
        if (!anySelected()){
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          openWarnModal();
          return false;
        }
        syncFormIdToSelection();
      }, true);
    }
    // Fetch interceptor (HDT teması XHR kullanıyor olabilir) — /cart/add çağrısı öncesi id doğrula
    if (!window.__vmFetchPatched){
      window.__vmFetchPatched = true;
      var origFetch = window.fetch;
      window.fetch = function(url, opts){
        try {
          var isCartAdd = (typeof url === 'string' && url.indexOf('/cart/add') !== -1);
          if (isCartAdd && isGuardedGiftAdd(opts)) return origFetch.apply(this, arguments);
          if (isCartAdd && getBoyutRadios().length && !isOzelOlcu()){
            if (!anySelected()){
              console.warn('[VariantMandatory] /cart/add engellendi — boyut seçilmedi');
              openWarnModal();
              return Promise.reject(new Error('Variant not selected'));
            }
            window.__vmLastCartAdd = Date.now(); // tıklama-kaybı sigortası bunu okur
            // Body içindeki id'yi selected variant id ile değiştir
            // [DV-SR-VM-GUARD 2026-08-01] dv-sabit-rulo kesim kalemi gonderiyorsa id'ye DOKUNMA
            var __dvSrKesim = false;
            try {
              if (opts && opts.body instanceof FormData) __dvSrKesim = !!opts.body.get('properties[_kesimVaryantId]');
              else if (opts && typeof opts.body === 'string') __dvSrKesim = opts.body.indexOf('_kesimVaryantId') !== -1;
            } catch(eG){}
            var selVal = getSelectedValue();
            var selId = __variantMap[selVal];
            if (!__dvSrKesim && selId && opts && opts.body){
              if (typeof opts.body === 'string'){
                try {
                  var parsed;
                  try { parsed = JSON.parse(opts.body); } catch(e){ parsed = null; }
                  if (parsed && parsed.id){
                    parsed.id = selId;
                    opts.body = JSON.stringify(parsed);
                  } else {
                    opts.body = opts.body.replace(/(\Wid\W*[:=]\s*)(\d{10,})/g, '$1'+selId);
                  }
                } catch(e){}
              } else if (opts.body instanceof FormData){
                opts.body.set('id', String(selId));
              }
            }
          }
        } catch(e) { console.error('[VariantMandatory] fetch patch error:', e); }
        return origFetch.apply(this, arguments);
      };
    }
  }

  // 2026-07-29 İNDİRİM NETLİĞİ (Claude): müşteri yüzdeyi değil parayı anlar.
  // Seçili ölçünün gerçek kazancını TL olarak fiyatın altına yazar; indirim yoksa gizler.
  function formatTL(kurus){
    try { return (kurus/100).toLocaleString('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2})+' TL'; }
    catch(e){ return Math.round(kurus/100)+' TL'; }
  }
  function updateSavings(){
    var val = getSelectedValue();
    if (!val) return;
    var p = __priceMap[val], c = __cmpMap[val];
    var el = document.getElementById('dv-kazanc');
    // [DV-ROZET-KAPISI 2026-07-31] "Bu olcude kazanciniz" satiri da SADECE gercek firsat
    // kampanyasi varken cikar. Kalici x1,43 compare_at farki indirim degildir; onu kazanc
    // diye yazmak indirim rozetiyle ayni yanlis. Isaret kaynagi: varyantin
    // dolcevita.campaign_price metafield'i -> window.__DV_KAMPANYA__ (main-product.liquid).
    // Ustu cizili fiyat bilincli olarak yerinde birakildi; sadece "kazanc" iddiasi kalkti.
    var dvVaryantId = __variantMap[val];
    var dvKampanya = (window.__DV_KAMPANYA__ || {})[dvVaryantId] || null;
    if (!dvKampanya){ if (el) el.style.display='none'; return; }
    if (!(c && p && c > p)){ if (el) el.style.display='none'; return; }
    if (!el){
      var priceItem = document.querySelector('.hdt-product__price');
      if (!priceItem) return;
      el = document.createElement('div');
      el.id = 'dv-kazanc';
      el.style.cssText = 'margin:6px 0 2px;font-size:14px;font-weight:600;color:#1a7f37;';
      priceItem.appendChild(el);
    }
    el.style.display = 'block';
    el.textContent = '✓ Bu ölçüde kazancınız: ' + formatTL(c - p) +
      '  (' + formatTL(c) + ' yerine ' + formatTL(p) + ')';
  }

  // 2026-07-28 DÜZELTME (Claude): deselectAll() ölçü işaretini kaldırıyor ama sayfa
  // "Boyut: X" + o varyantın fiyatını seçili gibi göstermeye devam ediyordu. Müşteri
  // butona basınca "Lütfen Ölçü Seçin" engeline çarpıyordu → sepete ekleme oranı
  // %10'dan %1'in altına düştü. Bu fonksiyon sayfanın ZATEN GÖSTERDİĞİ ölçüyü
  // gerçekten işaretler: önce ?variant= parametresi (tüm reklam trafiği), yoksa
  // hidden form id'si, o da yoksa ilk seçenek. Yanlış-varyant koruması aynen
  // yerinde: syncFormIdToSelection + fetch interceptor değişmedi.
  function preselectInitial(){
    var rs = getBoyutRadios();
    if (!rs.length || anySelected()) return;
    var urlWant = null;
    try { urlWant = new URLSearchParams(window.location.search).get('variant'); } catch(e){}
    var want = urlWant;
    if (!want){ var idInput = getIdInput(); if (idInput && idInput.value) want = idInput.value; }
    var target = null;
    if (want){
      for (var i=0;i<rs.length;i++){
        if (String(__variantMap[rs[i].value]) === String(want)){ target = rs[i]; break; }
      }
    }
    if (!target) target = rs[0];
    // 2026-07-29: URL'de açık variant yoksa ve seçilen ölçü TÜKENDİYSE stoktaki ilk ölçüye geç.
    // Ölçüm: 300 aktif ürünün 85'i varsayılan olarak TÜKENDİ butonu gösteriyordu.
    // Reklam URL'sindeki varyant dürüstçe korunur (stok dışıysa TÜKENDİ görünür).
    if (!urlWant && target && __availMap[target.value] === false){
      for (var j=0;j<rs.length;j++){
        if (__availMap[rs[j].value] !== false){ target = rs[j]; break; }
      }
    }
    try { target.click(); } catch(e){}
    if (!target.checked){
      target.checked = true;
      try { target.dispatchEvent(new Event('change', { bubbles: true })); } catch(e){}
    }
    syncFormIdToSelection();
    updateSavings();
    console.log('[VariantMandatory] varsayılan ölçü işaretlendi →', target.value);
  }

  // 2026-07-29c TIKLAMA-KAYBI SİGORTASI (Claude)
  // Belirti: sayfa açıldıktan sonraki İLK "Sepete Ekle" tıklamasında hiçbir /cart/add
  // isteği çıkmıyor (tema bileşeni muhtemelen ilk etkileşimde tembel yükleniyor);
  // ikinci tıklama çalışıyor. Gerçek müşteri ikinci kez basmaz.
  // Çözüm: tıklamadan 1600ms sonra /cart/add görülmediyse ve sepet değişmediyse
  // eklemeyi kendimiz yapıp müşteriyi sepete götürürüz. Çifte-ekleme korumalı.
  // v6: "kendin ekle" yerine "YENİDEN TIKLA" — tema geç uyandığında kendi eklemesini
  // yapar; kör ekleme çifte-adet üretti (ölçüldü: adet 2). Yeniden tık tek doğal ekleme üretir.
  // Son çare (yeniden tık da öldüyse): sepet DEĞİŞMEDİYSE tek ekleme + /cart.
  var __vmSigortaMesgul = false;
  function attachClickInsurance(){
    document.addEventListener('click', function(e){
      if (!e.isTrusted) return; // kendi sentetik yeniden-tıkımızı yeniden sigortalama
      var b = e.target && e.target.closest && e.target.closest('button[name="add"]');
      if (!b || b.disabled || __vmSigortaMesgul) return;
      if (isOzelOlcu()) return;
      if (!anySelected()) return; // korumanın modalı devrede, sigorta karışmaz
      var val = getSelectedValue();
      var vid = __variantMap[val];
      if (!vid || __availMap[val] === false) return;
      var tikZamani = Date.now();
      __vmSigortaMesgul = true;
      var birak = function(){ __vmSigortaMesgul = false; };
      var eklemeVar = function(){
        return window.__vmLastCartAdd && window.__vmLastCartAdd >= tikZamani - 50;
      };
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.json(); })
        .then(function(sepetOnce){
          // ADIM 1 (+1500ms): ekleme yoksa YENİDEN TIKLA — tema artık uyanmıştır
          setTimeout(function(){
            if (eklemeVar()){ birak(); return; }
            console.warn('[VariantMandatory] ilk tık yutuldu — yeniden tıklanıyor');
            try { b.click(); } catch(err){}
            // ADIM 2 (+3400ms): hâlâ yoksa ve sepet değişmediyse SON ÇARE tek ekleme
            setTimeout(function(){
              if (eklemeVar()){ birak(); return; }
              fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
                .then(function(r){ return r.json(); })
                .then(function(sepetSonra){
                  if (sepetSonra.item_count !== sepetOnce.item_count){ birak(); return; }
                  console.warn('[VariantMandatory] yeniden tık da yutuldu — son çare ekleme');
                  var fallbackForm = b.form || b.closest('form[action*="/cart/add"]');
                  var fd = buildDvAttributionFormData(fallbackForm, vid);
                  fetch('/cart/add.js', { method: 'POST', body: fd })
                    .then(function(r){ birak(); if (r.ok) window.location.href = '/cart'; })
                    .catch(birak);
                }).catch(birak);
            }, 1900);
          }, 1500);
        }).catch(birak);
    }, true);
  }

  function init(){
    if (isOzelOlcu()) return;
    if (!getBoyutRadios().length) return;
    deselectAll();
    loadVariantMap().then(function(){
      attachRadioListeners();
      interceptATC();
      attachClickInsurance();
      preselectInitial();
      console.log('[VariantMandatory] aktif — variants:', Object.keys(__variantMap).length);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
